import UnderDevelopment from './Index.vue'

UnderDevelopment.install = function(Vue) {
  Vue.component(UnderDevelopment.name, UnderDevelopment)
}

export default UnderDevelopment
